function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "energizer");

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 401.0546,
  cy: 731.11433,
  rx: 243.5,
  ry: 37.67914,
  fill: "var(--primaryColor)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M585.88825,225.23478s5.94383,27.34161-14.26519,38.0405c0,0,4.75506,60.627,35.663,61.81581s30.9079-32.09667,30.9079-32.09667l-4.75506-17.83149s-22.58654-13.07642-8.32136-38.0405Z",
  transform: "translate(-191.28027 -65.60326)",
  fill: "#f7c4a7"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 420.16643,
  cy: 118.6191,
  r: 55.87198,
  fill: "var(--primaryColor)"
});

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  points: "361.323 286.829 361.323 353.4 459.99 349.834 452.857 284.452 361.323 286.829",
  fill: "#f7c4a7"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 420.76082,
  cy: 142.98879,
  r: 35.66297,
  fill: "#f7c4a7"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M568.05676,263.27528s-20.209-3.5663-27.3416,0-15.454,2.37753-23.77532,36.85173l-15.454,71.32594s-2.37753,21.39778,15.454,19.02024,16.64272-33.28543,16.64272-33.28543l11.88766-27.34161L566.868,306.07084Z",
  transform: "translate(-191.28027 -65.60326)",
  fill: "#f7c4a7"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M635.8164,277.54046s28.53038,3.5663,30.90791,19.02025-10.69889,78.45853-10.69889,78.45853l-20.209-20.209L646.51529,315.581Z",
  transform: "translate(-191.28027 -65.60326)",
  fill: "#f7c4a7"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M562.70732,262.68089l.59438,21.99217L546.659,320.336l3.5663,43.98433,95.38867.28742-.28742-20.49643s13.07642-16.64272,5.94383-30.90791-12.482-36.25735-12.482-36.25735l-9.51013-5.94383s16.04834,37.44612-17.2371,31.50229-35.06858-43.38994-35.06858-43.38994Z",
  transform: "translate(-191.28027 -65.60326)",
  fill: "#d0cde1"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M534.77133,502.21716l-16.64272,93.91248-19.02025,136.708-8.32136,15.454,7.13259,15.45395,20.209-9.51012L526.45,717.38373s28.53037-34.4742,23.77531-78.45853L601.3422,516.48235Z",
  transform: "translate(-191.28027 -65.60326)",
  fill: "#f7c4a7"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M616.79615,511.72729l11.88766,116.499s-2.37753,32.09667,4.75506,60.627,11.88766,78.45853,11.88766,78.45853h23.77531l-4.75506-146.21817,15.454-118.87656Z",
  transform: "translate(-191.28027 -65.60326)",
  fill: "#f7c4a7"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M600.15344,404.73838s-49.92816-3.56629-49.92816,2.37753v11.88766s-9.51012,15.45395-8.32136,29.71914-45.17309,46.36186-15.45395,60.627,68.9484,19.02025,74.89223,14.26519,9.51013-23.77531,9.51013-23.77531,0,21.39778,10.69889,22.58655,74.89223-11.88766,74.89223-22.58655-47.57226-106.39471-47.57226-106.39471S614.41862,405.92715,600.15344,404.73838Z",
  transform: "translate(-191.28027 -65.60326)",
  fill: "var(--primaryColor)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M496.73083,749.4804s-4.75506-8.32135-9.51013-2.37753-22.58654,20.209-22.58654,20.209S420.64983,779.19954,450.369,797.031c0,0,26.15284,0,36.85173-8.32136s21.39778-4.75506,21.39778-4.75506,16.64272-1.18877,17.83149-8.32136-6.22745-30.67081-6.22745-30.67081S512.18478,755.42423,496.73083,749.4804Z",
  transform: "translate(-191.28027 -65.60326)",
  fill: "var(--tertiaryColor)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M654.83665,756.613s-14.26518-3.5663-14.26518,0-20.209,24.96408-3.5663,34.4742,19.02025,7.13259,20.209,16.64272,32.09667,16.64272,36.85174,10.69889,8.32136-16.64272,2.37753-21.39778-24.96408-34.4742-24.96408-40.418S654.83665,756.613,654.83665,756.613Z",
  transform: "translate(-191.28027 -65.60326)",
  fill: "var(--tertiaryColor)"
});

var _ref16 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 434.74146,
  cy: 227.47651,
  rx: 4.17333,
  ry: 2.08666,
  fill: "var(--primaryColor)"
});

var _ref17 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 435.2157,
  cy: 231.93439,
  rx: 8.53635,
  ry: 4.36302,
  fill: "var(--tertiaryColor)"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 424.78239,
  y: 234.59014,
  width: 20.48724,
  height: 14.98603,
  fill: "var(--tertiaryColor)"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  x: 410.64999,
  y: 258.01767,
  width: 48.56234,
  height: 73.4126,
  fill: "var(--tertiaryColor)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M652.67411,322.7673c0,7.2289-11.91005,4.74242-26.36783,4.74242s-26.74723,2.29678-26.74723-4.93211,12.28944-14.79634,26.74723-14.79634S652.67411,315.53841,652.67411,322.7673Z",
  transform: "translate(-191.28027 -65.60326)",
  fill: "var(--tertiaryColor)"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 408.84787,
  y: 264.9416,
  width: 52.54597,
  height: 5.6909,
  fill: "var(--primaryColor)"
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  x: 409.22726,
  y: 319.95363,
  width: 52.54597,
  height: 5.6909,
  fill: "var(--primaryColor)"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  x: 408.84787,
  y: 295.29306,
  width: 52.54597,
  height: 11.3818,
  fill: "var(--primaryColor)"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M652.29472,394.47263c0,2.40963.765,9.29514-25.41935,9.29514-29.59268,0-27.12662-7.2649-27.12662-9.67453s13.0879.94848,27.12662.94848S652.29472,392.063,652.29472,394.47263Z",
  transform: "translate(-191.28027 -65.60326)",
  fill: "var(--tertiaryColor)"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  x: 422.69572,
  y: 231.93439,
  width: 24.28117,
  height: 8.15696,
  fill: "var(--primaryColor)"
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  x: 412.92635,
  y: 275.46976,
  width: 3.22484,
  height: 17.83148,
  fill: "#fff",
  opacity: 0.1
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  x: 412.92635,
  y: 309.42546,
  width: 3.22484,
  height: 6.63938,
  fill: "#fff",
  opacity: 0.1
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M660.78048,360.75405s-22.58655-29.71913-21.39778-8.32135,14.26519,32.09667,16.64272,32.09667S667.91307,382.15184,660.78048,360.75405Z",
  transform: "translate(-191.28027 -65.60326)",
  fill: "#f7c4a7"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M552.60281,383.64728c1.78315.2877,30.31352-10.41119,30.31352-10.41119l17.83149-2.37753-48.145,20.13413Z",
  transform: "translate(-191.28027 -65.60326)",
  opacity: 0.1
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M515.75108,363.13159s9.51012-5.94383,28.53037-3.5663l36.85174-9.51013s34.4742-20.209,47.55062,4.75507S579.94442,371.453,579.94442,371.453s-41.6068,33.28543-66.57087,15.454Z",
  transform: "translate(-191.28027 -65.60326)",
  fill: "#f7c4a7"
});

var _ref31 = /*#__PURE__*/React.createElement("circle", {
  cx: 369.04951,
  cy: 78.20107,
  r: 16.64272,
  fill: "var(--primaryColor)"
});

var _ref32 = /*#__PURE__*/React.createElement("circle", {
  cx: 471.28335,
  cy: 73.44601,
  r: 16.64272,
  fill: "var(--primaryColor)"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M644.73215,131.91668a16.64235,16.64235,0,0,1,14.85956-16.54433,16.64274,16.64274,0,1,0,0,33.08866A16.64235,16.64235,0,0,1,644.73215,131.91668Z",
  transform: "translate(-191.28027 -65.60326)",
  fill: "var(--primaryColor)"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M541.73413,157.26631a16.64236,16.64236,0,0,1-.96479-22.21691,16.81036,16.81036,0,0,0-1.34253,1.17768,16.64272,16.64272,0,0,0,23.29511,23.77516,16.81157,16.81157,0,0,0,1.20482-1.31823A16.64236,16.64236,0,0,1,541.73413,157.26631Z",
  transform: "translate(-191.28027 -65.60326)",
  fill: "var(--primaryColor)"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M611.44671,158.06952c-19.69611,0-35.663,9.314-35.663,20.8034,0,5.14084,3.20946,9.83924,8.50725,13.469l6.86551-4.97454-1.867,7.79322c.77468.359,1.5657.70648,2.39074,1.02761l10.25636-11.9658v14.7a59.86944,59.86944,0,0,0,9.51013.75394c19.69611,0,35.663-9.314,35.663-20.8034S631.14282,158.06952,611.44671,158.06952Z",
  transform: "translate(-191.28027 -65.60326)",
  fill: "var(--primaryColor)"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M645.92091,139.04927s-2.58476,11.88766,13.56719,16.64272",
  transform: "translate(-191.28027 -65.60326)",
  fill: "var(--tertiaryColor)"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M575.78374,141.21292s5.94383,13.2903-11.88766,19.23413",
  transform: "translate(-191.28027 -65.60326)",
  fill: "var(--tertiaryColor)"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M818.09989,724.9368a28.84306,28.84306,0,0,0-11.20545-46.239,20.47144,20.47144,0,1,0-20.50342,0,28.84292,28.84292,0,0,0-11.20532,46.239,40.01239,40.01239,0,1,0,42.91419,0Z",
  transform: "translate(-191.28027 -65.60326)",
  fill: "var(--primaryColor)"
});

var _ref39 = /*#__PURE__*/React.createElement("circle", {
  className: "growCircle",
  cx: 257.57201,
  cy: 394.87841,
  r: 29.78906,
  fill: "var(--tertiaryColor)"
});

var _ref40 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 433.06598,
  cy: 473.26125,
  rx: 6.77024,
  ry: 14.89453,
  transform: "translate(-392.58842 312.30692) rotate(-38.9914)",
  fill: "#fff"
});

var _ref41 = /*#__PURE__*/React.createElement("circle", {
  className: "growCircle",
  cx: 62.72208,
  cy: 306.97708,
  r: 29.78906,
  fill: "var(--primaryColor)"
});

var _ref42 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 234.392,
  cy: 367.29271,
  rx: 14.89453,
  ry: 6.77024,
  transform: "translate(-372.53686 432.37915) rotate(-74.90993)",
  fill: "#fff"
});

var _ref43 = /*#__PURE__*/React.createElement("circle", {
  className: "growCircle",
  cx: 18.56904,
  cy: 131.92373,
  r: 18.56442,
  fill: "var(--primaryColor)"
});

var _ref44 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 197.62822,
  cy: 194.23176,
  rx: 9.28221,
  ry: 4.21919,
  transform: "translate(-232.63624 268.87631) rotate(-74.90993)",
  fill: "#fff"
});

var _ref45 = /*#__PURE__*/React.createElement("circle", {
  className: "growCircle",
  cx: 210.91581,
  cy: 591.1814,
  r: 18.56442,
  fill: "var(--primaryColor)"
});

var _ref46 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 389.97499,
  cy: 653.48943,
  rx: 9.28221,
  ry: 4.21919,
  transform: "matrix(0.26034, -0.96552, 0.96552, 0.26034, -533.78592, 794.28638)",
  fill: "#fff"
});

var _ref47 = /*#__PURE__*/React.createElement("circle", {
  className: "growCircle",
  cx: 787.6504,
  cy: 373.32632,
  r: 29.78906,
  fill: "var(--primaryColor)"
});

var _ref48 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 767.33968,
  cy: 373.32632,
  rx: 6.77024,
  ry: 14.89453,
  fill: "#fff"
});

var _ref49 = /*#__PURE__*/React.createElement("circle", {
  className: "growCircle",
  cx: 691.51299,
  cy: 182.40556,
  r: 29.78906,
  fill: "var(--tertiaryColor)"
});

var _ref50 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 870.8783,
  cy: 231.56015,
  rx: 14.89453,
  ry: 6.77024,
  transform: "translate(-161.52557 489.31459) rotate(-35.91853)",
  fill: "#fff"
});

var _ref51 = /*#__PURE__*/React.createElement("circle", {
  className: "growCircle",
  cx: 767.33968,
  cy: 18.56575,
  r: 18.56442,
  fill: "var(--tertiaryColor)"
});

var _ref52 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 951.19459,
  cy: 73.91827,
  rx: 9.28221,
  ry: 4.21919,
  transform: "translate(-53.77544 506.45559) rotate(-35.91853)",
  fill: "#fff"
});

var _ref53 = /*#__PURE__*/React.createElement("circle", {
  className: "growCircle",
  cx: 627.87274,
  cy: 496.54469,
  r: 18.56442,
  fill: "var(--primaryColor)"
});

var _ref54 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 811.72765,
  cy: 551.8972,
  rx: 9.28221,
  ry: 4.21919,
  transform: "translate(-360.69368 515.52627) rotate(-35.91853)",
  fill: "#fff"
});

var SvgComplements = function SvgComplements(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aaa444b1-ec30-4a51-a2af-6b879f86a07d",
    "data-name": "Layer 1",
    width: 817.43945,
    height: 768.79347,
    viewBox: "0 0 817.43945 768.79347",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComplements, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/complements.709c58a5.svg";
export { ForwardRef as ReactComponent };